import {
  BANK_ACCOUNT_ERROR,
  BANK_ACCOUNT_LOADING,
  BANK_ACCOUNT_SUCCESS,
  DOCUMENTS_SUCCESS,
  DOCUMENT_ITEM_SUCCESS,
  DOCUMENTS_LOADING,
  DOCUMENTS_ERROR,
  POST_FILING_DECISION_LOADING,
  POST_FILING_DECISION_SUCCESS,
  POST_FILING_DECISION_ERROR,
  SET_FILING_DECISION,
  CLOSE_APP_ERROR,
  CLOSE_APP_SUCCESS,
  CLOSE_APP_LOADING,
  PROOF_FILES_LOADING,
  PROOF_FILES_ERROR,
  FETCH_PROOF_FILES_SUCCESS,
  POST_PROOF_FILE_SUCCESS,
  DELETE_PROOF_FILE_SUCCESS,
  PRINT_COPIES_SUCCESS, SET_BACK_TO_DECISION_PERMISSION,
} from '@/app/file/store/types';

export const mutations = {
  [BANK_ACCOUNT_ERROR]: (state) => {
    state.bankAccountLoadingStatus = 'error';
  },
  [BANK_ACCOUNT_LOADING]: (state) => {
    state.bankAccountLoadingStatus = 'loading';
  },
  [BANK_ACCOUNT_SUCCESS]: (state, item) => {
    state.bankAccountLoadingStatus = 'success';
    state.bankAccount = item;
  },
  [DOCUMENTS_SUCCESS]: (state, response) => {
    state.documentsLoadingStatus = 'success';
    state.documents = response;
  },
  [DOCUMENTS_ERROR]: (state) => {
    state.documentsLoadingStatus = 'error';
  },
  [DOCUMENTS_LOADING]: (state) => {
    state.documentsLoadingStatus = 'loading';
  },
  [DOCUMENT_ITEM_SUCCESS]: (state) => {
    state.documentsLoadingStatus = 'success';
  },
  [PRINT_COPIES_SUCCESS]: (state) => {
    state.documentsLoadingStatus = 'success';
  },
  [POST_FILING_DECISION_SUCCESS]: (state) => {
    state.filingDecisionStatus = 'success';
  },
  [POST_FILING_DECISION_ERROR]: (state) => {
    state.filingDecisionStatus = 'error';
  },
  [POST_FILING_DECISION_LOADING]: (state) => {
    state.filingDecisionStatus = 'loading';
  },
  [SET_FILING_DECISION]: (state, data) => {
    switch (data) {
      case 0:
        state.filingDecision = 'eztx';
        break;
      case 1:
        state.filingDecision = 'self';
        break;
      default:
        break;
    }
  },
  [CLOSE_APP_SUCCESS]: (state) => {
    state.closeLoadingStatus = 'success';
  },
  [CLOSE_APP_LOADING]: (state) => {
    state.closeLoadingStatus = 'loading';
  },
  [CLOSE_APP_ERROR]: (state) => {
    state.closeLoadingStatus = 'error';
  },
  [PROOF_FILES_LOADING]: (state) => {
    state.proofLoadingStatus = 'loading';
  },
  [PROOF_FILES_ERROR]: (state) => {
    state.proofLoadingStatus = 'error';
  },
  [FETCH_PROOF_FILES_SUCCESS]: (state, resp) => {
    state.proofLoadingStatus = 'success';
    state.proofFiles = resp;
    if (state.proofFiles.length) {
      state.proofUploaded = true;
    }
    resp.forEach((file, ind) => {
      state.proofFiles[ind].name = file.filename;
    });
  },
  [POST_PROOF_FILE_SUCCESS]: (state, resp) => {
    state.proofLoadingStatus = 'success';
    state.proofUploaded = true;
    resp.uploadedFiles.forEach((file, index) => {
      const newFile = {
        ...resp.uploadedFiles[index],
        name: file.fileName,
      };
      state.proofFiles.push(newFile);
    });
  },
  [DELETE_PROOF_FILE_SUCCESS]: (state, id) => {
    state.proofLoadingStatus = 'success';
    const index = state.proofFiles.findIndex(file => file.id === id);
    state.proofFiles.splice(index, 1);
    if (!state.proofFiles.length) {
      state.proofUploaded = false;
    }
  },
  [SET_BACK_TO_DECISION_PERMISSION]: (state, permission) => {
    state.backToDecisionPermission = permission;
  },
};
